import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_TEACHER_MESSAGES } from '@/api/endpoints';
import { TEACHER_MESSAGES_QUERY_KEY } from '@/api/queryKeys';
import type { TeacherMessage } from '@/types/overview';
import { unwrapAxiosResponse } from '@/utils/axios';

interface Options {
  enabled?: boolean;
}

export const useTeacherMessages = ({ enabled = true }: Options = {}) =>
  useQuery<TeacherMessage[]>({
    queryKey: TEACHER_MESSAGES_QUERY_KEY,
    queryFn: () =>
      apiClient
        .get<TeacherMessage[]>(API_TEACHER_MESSAGES)
        .then(unwrapAxiosResponse),
    enabled,
  });
